export * from './icon-switch.component';
export * from './icon-switch.module';
